import React from 'react';


import {SkeletonItem} from 'src/components/skeleton';
import {WidthItem} from 'src/components/width-item';

import {FormSection} from '@pb/kit-component-form-section';
import {Group} from '@pb/kit-component-group';

export const AccountTeamSkeleton = () => (
    <FormSection headline="Account Team" info={() => <SkeletonItem width={140} height={28}/>}>
        <Group gap="xl">
            <WidthItem width={420}>
                <SkeletonItem width={58} height={17}/>
            </WidthItem>
            <WidthItem width={315}>
                <SkeletonItem width={26} height={17}/>
            </WidthItem>
            <SkeletonItem width={48} height={17}/>
        </Group>
        <Group direction="v" gap="s">
            <Group gap="xl" alignItems="center">
                <SkeletonItem width={420} height={32}/>
                <SkeletonItem width={315} height={32}/>
                <SkeletonItem width={68} height={17}/>
                <SkeletonItem width={108} height={18}/>
            </Group>
            <SkeletonItem width={195} height={18}/>
        </Group>
    </FormSection>
);
